import { apiAxios } from "@/api/axios";
import base from '../config'
let baseURL = base.baseURL

export default {
  //组织-列表
  organizationList: (data) => apiAxios('post', baseURL + '/manage.org.list', data),
  //组织-添加组织
  appendOrganization: (data) => apiAxios('post', baseURL + '/manage.org.store', data),
  //组织-删除组织
  deleteOrganization: (data) => apiAxios('post', baseURL + '/manage.org.delete', data),
  //组织-修改
  updateOrganization: (data) => apiAxios('post', baseURL + '/manage.org.update', data),
  //账号列表
  accountNumberList: (data) => apiAxios('post', baseURL + '/manage.admin.list', data),
  //工种类型
  worktypeList: (data) => apiAxios('post', baseURL + '/manage.worktype.list', data),
  //账号-开启和关闭账号(限制登录)
  updateUserForbidLogin: (data) => apiAxios('post', baseURL + '/manage.admin.forbidLogin', data),
  //账号-校验是否有进行中的订单配送单
  forbidLoginCheck: (data) => apiAxios('post', baseURL + '/manage.admin.forbidLoginCheck', data),
  //账号-添加
  addAccountNumber: (data) => apiAxios('post', baseURL + '/manage.admin.store', data),
  //账号-获取默认账号名
  usableDefaultUsername: (data) => apiAxios('post', baseURL + '/manage.admin.usableDefaultUsername', data),

  //账号-修改
  updateAccountNumber: (data) => apiAxios('post', baseURL + '/manage.admin.update', data),
  //角色-列表
  roleList: (data) => apiAxios('post', baseURL + '/manage.role.list', data),

  //角色-添加角色
  addRole: (data) => apiAxios('post', baseURL + '/manage.role.store', data),
  //角色-修改角色
  editRole: (data) => apiAxios('post', baseURL + '/manage.role.update', data),
  //权限-全部权限
  allAuth: (data) => apiAxios('post', baseURL + '/manage.auth.allAuth', data),
  //权限-设置角色的权限
  setRoleAuth: (data) => apiAxios('post', baseURL + '/manage.auth.setRoleAuth', data),
  //角色-关闭角色的分配权限
  setRoleAllotAuth: (data) => apiAxios('post', baseURL + '/manage.auth.setRoleAllotAuth', data),
  //权限-批量添加或删除权限
  batchSetRoleAuth: (data) => apiAxios('post', baseURL + '/manage.auth.batchSetRoleAuth', data),
  //角色-获取所有客户属性可选值
  getRoleAllotAuth: (data) => apiAxios('post', baseURL + '/manage.auth.getRoleAllotAuth', data),
  //角色-删除角色
  roleDelete: (data) => apiAxios('post', baseURL + '/manage.role.delete', data),
  //账号-子系统列表
  subsystemList: (data) => apiAxios('post', baseURL + '/manage.admin.subsystemList', data),
  //账号-绑定角色及子系统
  bindRole: (data) => apiAxios('post', baseURL + '/manage.admin.bindRole', data),
  //账号-自动下单地址设置
  setAutoOrderAddress: (data) => apiAxios('post', baseURL + '/manage.admin.setAutoOrderAddress', data),
  //账号-检品属性设置(批量)
  setInspectRate: (data) => apiAxios('post', baseURL + '/manage.admin.setInspectRate', data),
  //账号-设置跟进人员
  setFollower: (data) => apiAxios('post', baseURL + '/manage.admin.setFollower', data),
  //账号-设置默认封箱人，admin_id 和 sealer_id 均为有效配货账号 ID。
  setDefaultSealer: (data) => apiAxios('post', baseURL + '/manage.admin.setDefaultSealer', data, { isLoading: true, resolveError: true }),

  //-登录状态-权限下的组织树
  getAdminOrganization: (data) => apiAxios('post', baseURL + '/manage.auth.getAdminOrganization', data),

  //-从指定组织获取所有父级组织
  getPOrgIds: (data) => apiAxios('post', baseURL + '/manage.auth.getPOrgIds', data),
  //-自动下单前缀设置
  setAutoOrderPrefixAndMobile: (data) => apiAxios('post', baseURL + '/manage.admin.setAutoOrderPrefixAndMobile', data),
  //-账号-修改当前登录的头像
  updatePic: (data) => apiAxios('post', baseURL + '/manage.admin.updatePic', data),
  //-账号-修改密码-发送验证码
  sendAdminUpdatePwdCode: (data) => apiAxios('post', baseURL + '/manage.admin.sendAdminUpdatePwdCode', data),
  //-账号-修改当前账号的密码
  updatePwd: (data) => apiAxios('post', baseURL + '/manage.admin.updatePwd', data),

  //-任务列表
  serviceList: (data) => apiAxios('post', baseURL + '/dataExport.serviceList', data),
  //-任务列表-预约
  reserve: (data) => apiAxios('post', baseURL + '/dataExport.reserve', data),

  //-检品比例一览表
  inspectList: (data) => apiAxios('post', baseURL + '/manage.admin.inspectList', data),
  //-检品属性设置(批量)
  setInspectRate: (data) => apiAxios('post', baseURL + '/manage.admin.setInspectRate', data),

  // 进度列表
  dataSpeedList: (data) => apiAxios('post', baseURL + '/data.dataSpeed.list', data),
  // 进度列表统计-个人
  listByClass: (data) => apiAxios('post', baseURL + '/data.dataSpeed.listByClass', data),
  // 进度列表-按个人导出
  exportPersonal: (data) => apiAxios('post', baseURL + '/data.dataSpeed.exportPersonal', data),
  // 进度列表-按月导出
  exportMonth: (data) => apiAxios('post', baseURL + '/data.dataSpeed.exportMonth', data),

  //指纹采集
  fingerprintEnroll: (data) => apiAxios('post', baseURL + '/manage.admin.fingerprintEnroll', data),
  //指纹采集-校验是否有指纹
  fingerprintHasBound: (data) => apiAxios('post', baseURL + '/manage.admin.fingerprintHasBound', data),
  //指纹采集-指纹校验
  fingerprintVerify: (data) => apiAxios('post', baseURL + '/manage.admin.fingerprintVerify', data),
}
